import statistic from './statistic'

export default {
  settings: {
    hasArgusControls: true,
    isTimerDisabled: true,
    resetScoreOnPeriodChange: true,
    scoreInPoints: true,
    hasOvertime: false
  },
  actionTypes: {
    score: ['POINT', 'ADJUST_POINTS', 'RED_CARD']
  },
  modules: {
    info: [
      // eсли нет никаких доп параметров, то просто строка
      // 'timer',
      // 'players',
      {
        type: 'periods',
        // если не дефолтный child-component
        //   component: 'component-name'
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    // если не дефолтный root-component
    // info: {
    //   component: 'component-name',
    //   childComponents: [
    //     {
    //       type: 'periods',
    //     }
    //   ]
    // },
    score: {
      // если не дефолтный компонент
      // component: 'component-name',
      score: ingameData => ingameData.score,
      total: ingameData => ingameData.sets,
      meta: {
        dot: true
      }
    },
    // statistic: [
    //   {
    //     type: 'PT1',
    //     getter: imgameData => ingameData.statistic['PT1'],
    //     setter: event => {...} // if you need some custom behaviour, noy just increment
    //   }
    // ]
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: {
      additionalPeriods: [{
        type: 'score',
        component: 'event-log-score',
        adjustEvents: ['ADJUST_POINTS', 'ADJUST_SETS']
      }]
    }
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    sets: {
      home: 0,
      away: 0
    }
  }
}
